import type { ReactNode } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { gestorSesion } from './gestor';

// Pone la sesión a disposición de toda la consola, con el gestor ya construido
// para que el token tenga una sola fuente. Igual que en el admin.

interface Props {
  children: ReactNode;
}

export function ProveedorSesion({ children }: Props) {
  return (
    <AuthProvider
      userManager={gestorSesion}
      // Al volver de Keycloak se borra `?code=…&state=…` de la dirección: si se
      // queda, recargar reintenta canjear un código ya usado. Ver el admin.
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      {children}
    </AuthProvider>
  );
}
